module.exports = __webpack_public_path__ + "static/media/newyork.fa7cf03d.jpg";